import { CommonPlayerLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/player/logic/common-player-logic';

export class ChartPlayerLogic extends CommonPlayerLogic {
    public handleChartTitleMouseDown() {}
    public onTitleEditorUpdate() {}
    public onChartSourceUpdate() {}
    public getChartHitAreaProps() {
        return [];
    }
    public handlePlotBlankMouseDown() {}
}
